'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const skeletonLoader = "_skeleton-loader_igt8w_1";
const styles = {
	skeletonLoader: skeletonLoader
};

const SkeletonLoader = (props) => {
  return React__default.default.createElement("div", { className: styles.skeletonLoader, "data-zds": true }, props.children);
};

exports.SkeletonLoader = SkeletonLoader;
//# sourceMappingURL=SkeletonLoader.cjs.js.map
